import { useMemo, useRef, useEffect, useCallback } from "react";
import { throttle } from "../../throttle";

export const useThrottledActivity = (
  onActivity: () => void | Promise<void>,
  throttleMs: number,
  enabled: boolean,
) => {
  const throttledFnRef = useRef<(() => void) | null>(null);
  const enabledRef = useRef(enabled);
  const onActivityRef = useRef(onActivity);

  // Keep refs fresh
  useEffect(() => {
    enabledRef.current = enabled;
    onActivityRef.current = onActivity;
  }, [enabled, onActivity]);

  const throttledFn = useMemo(() => {
    return throttle(() => {
      // Use ref to get latest callback
      if (onActivityRef.current) {
        onActivityRef.current();
      }
    }, throttleMs);
  }, [throttleMs]);

  useEffect(() => {
    throttledFnRef.current = throttledFn;
  }, [throttledFn]);

  const trigger = useCallback(() => {
    if (enabledRef.current && throttledFnRef.current) {
      throttledFnRef.current();
    }
  }, []);

  return { trigger };
};
